<template >
  <CSidebar v-if="!isMobile" id="mysidebar" fixed :minimize="minimize" :show.sync="show">
    <!-- <CSidebarBrand :imgFull="{ width: 118, height: 46, alt: 'Logo', src: 'https://www.ascent24.io/wp-content/uploads/2019/03/logo.png'}" :imgMinimized="{ width: 118, height: 46, alt: 'Logo', src: 'img/brand/coreui-signet-white.svg'}" :wrappedInLink="{ href: 'https://www.ascent24.io/', target: '_blank'}" /> -->
    <!-- <CRenderFunction flat :content-to-render="nav" /> -->
    <div class="c-sidebar-brand" @click="goTo()">
      <a rel="noopener">
        <span class="side-bar-brand-logo-full">

        </span>
        <span class="side-bar-brand-logo-minimized">

        </span>
<!--        <img-->
<!--          height="65"-->
<!--          alt="Logo"-->
<!--          src="@/assets/az/img/svg/logo.svg"        -->
<!--          class="c-sidebar-brand-full"-->
<!--        />-->
        <!-- src="/img/maing_fong_logo.82a52c25.svg" -->
<!--        <img-->
<!--          height="65"-->
<!--          alt="Logo"-->
<!--          src="@/assets/az/img/svg/logo.svg"  -->
<!--          class="c-sidebar-brand-minimized"-->
<!--        />-->
        <!-- src="/img/maing_fong_logo.82a52c25.svg" -->
      </a>
      <CBadge color="success">{{version}}</CBadge>
    </div>
    <span class="brand-logo-mob c-header-brand mx-auto d-lg-none">

    </span>
<!--    <img-->
<!--      src="@/assets/az/img/svg/logo.svg" -->
<!--      width="auto"-->
<!--      height="65"-->
<!--      alt="CoreUI Logo"-->
<!--      class="c-header-brand mx-auto d-lg-none"-->
<!--    />-->

<!-- src="/img/maing_fong_logo.82a52c25.svg" -->
    <!-- <CSidebarBrand :imgFull="{ width: auto, height: 46, alt: 'Logo', src: 'https://mmvgo.com/wp-content/uploads/2018/12/Logo-Maing-Fong.jpg'}" :imgMinimized="{ width: auto, height: 46, alt: 'Logo', src: 'https://mmvgo.com/wp-content/uploads/2018/12/Logo-Maing-Fong.jpg'}" :wrappedInLink="{ href: 'https://www.ascent24.io/', target: '_blank'}" /> -->

    <TheHeaderDropdownAccnt v-if="minimize&&isNeedLogo" style="list-style: none;" class="c-avatar-img square" />
    <!-- <avatar v-if="minimize"
          class="c-avatar-img square"
          :username="getUserName"
          :size="40"
          color="#fff"
          @click.native="showUserInfo = !showUserInfo"
    ></avatar>-->
    <!-- {{hello}}  -->
    <!-- {{b2b_registration_aggregate}} -->    
    <div v-if="showUserInfo">
      <cUserInfo></cUserInfo>
      <!-- <CDropdownHeader tag="div" class="text-center" style="padding: 0px;">
        <div class="profile-drop-wrap">
          <div class="head" v-if="userLogoDet.logoDet">
            <div class="profile">
              <avatar
                class="c-avatar-img square"
                :username="getUserName"
                :size="80"
                color="#fff"
              ></avatar>
             
            </div>
            <div class="details">
              <div class="name">{{ getUserName }}</div>
              <div
                class="profile-t-tag"
                v-if="
                  userLogoDet.logoDet.roles &&
                    userLogoDet.logoDet.roles.length > 0
                "
              >
                <div
                  class="role"
                  v-for="(role, index) in userLogoDet.logoDet.roles"
                  :key="'r' + index"
                >
                  <div>{{ role }}</div>
                </div>
              </div>
             
              <div class="email" v-if="userLogoDet.logoDet.agencyname">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  class="c-icon c-icon-custom-size"
                  height="42"
                >
                  <path
                    d="M19.294 16.109l-3.414-2.219 1.287-2.359c0.288-0.519 0.457-1.137 0.458-1.796v-3.735c0-2.9-2.351-5.25-5.25-5.25s-5.25 2.351-5.25 5.25v0 3.735c0.001 0.658 0.17 1.277 0.468 1.815l-0.010-0.019 1.287 2.359-3.414 2.219c-1.033 0.676-1.706 1.828-1.706 3.137 0 0.002 0 0.005 0 0.007v-0 3.997h17.25v-3.997c0-0.002 0-0.005 0-0.007 0-1.309-0.673-2.461-1.692-3.128l-0.014-0.009zM19.5 21.75h-14.25v-2.497c0-0.001 0-0.003 0-0.004 0-0.785 0.404-1.477 1.015-1.877l0.009-0.005 4.578-2.976-1.952-3.578c-0.173-0.311-0.274-0.682-0.275-1.077v-3.735c0-2.071 1.679-3.75 3.75-3.75s3.75 1.679 3.75 3.75v0 3.735c-0 0.395-0.102 0.766-0.281 1.089l0.006-0.012-1.952 3.579 4.578 2.976c0.62 0.406 1.024 1.097 1.024 1.882 0 0.001 0 0.003 0 0.004v-0z"
                  ></path>
                </svg>
                <div v-if="userLogoDet.logoDet.agencyname">
                  {{ userLogoDet.logoDet.agencyname }}
                </div>
              </div>
              <div class="address" v-if="userLogoDet.logoDet.email">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  class="c-icon c-icon-custom-size"
                  height="42"
                >
                  <path
                    d="M12.872 1.201c-0.242-0.175-0.545-0.279-0.872-0.279s-0.63 0.105-0.876 0.282l0.004-0.003-10.378 7.413v14.636h22.5v-14.636zM21.75 18.876l-5.814-3.737 5.814-4.522zM12 2.422l9.301 6.644-6.703 5.213-2.598-1.67-2.598 1.67-6.703-5.213zM2.25 10.617l5.814 4.522-5.814 3.737zM21.75 21.75h-19.5v-1.091l9.75-6.268 9.75 6.268z"
                  ></path>
                </svg>
                <div v-if="userLogoDet.logoDet.email">
                  {{ userLogoDet.logoDet.email }}
                </div>
              </div>
             
            </div>
          </div>

          <div class="body">
            <cLoginInfo
              
              @showAlert="showAlert"
            ></cLoginInfo>
          </div>
          <div class="foot">
            <div class="d-flex w-100">
              <div class="lan-drop">
                <cLanguagePicker
                  v-model="language"
                  ctrlName="en_name"
                  :isShowCode="true"
                  :isMultiple="false"
                  :isSearchable="true"
                  :url="languageListURL"
                  rules="_required"
                  :selValue="language"
                />
              </div>
              <div class="logout" @click="onLogout">
                <div class="d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    class="c-icon c-icon-custom-size"
                    height="42"
                  >
                    <path
                      d="M18 9.375v-2.625c0-3.314-2.686-6-6-6s-6 2.686-6 6v0 2.625h-1.875v6c0 4.342 3.533 7.875 7.875 7.875s7.875-3.533 7.875-7.875v-6zM7.5 6.75c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5v0 2.625h-9zM18.375 15.375c0 3.515-2.86 6.375-6.375 6.375s-6.375-2.86-6.375-6.375v-4.5h12.75z"
                    ></path>
                  </svg>
                  <div>Logout</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CDropdownHeader>-->
    </div>
    <CRenderFunction flat :content-to-render="nav" />
    <a href="https://ascent24.io" target="_blank" class="poweredbytag">Powered by Ascent24.io</a>
    <CSidebarMinimizer v-if="!isNeedLogo"  class="d-md-down-none" @click.native="minimize = !minimize" />

  </CSidebar>
  <!-- <component v-else-if="isMobile" :nav="nav" :show="show"  :minimize="minimize" v-bind:is="currentView">
   
</component> -->
  <aSideMenu v-else-if="isMobile" :nav="nav" :show="show"  :minimize="minimize"> </aSideMenu>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

import apiGetOrgCurrencyLs from "./../services/apiGetOrgCurrencyLs.js";
import cUserInfo from "./../components/userinfo/cUserInfo";
import base from "./../config/base";
import navs from "./_nav";
// import { menu } from "./../util/temp/temp.js";
import { mapActions, mapGetters } from "vuex";
import { PATHNAME, COMPONENT_NAME,  } from "../util/constants";
import apiGetMenus from "./../services/apiGetMenus";
import apiGetMenuCount from "./../services/apiGetMenuCount";
import Logger from "./../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../config/API_DATA";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "./../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  addClassToBody,
  addClassToContainer,checkIsSystemLogin
} from "./../util/util";

import router, { navigate, goBack,  navigateReplace, } from "./../router/index";
import cLanguagePicker from "./../components/cLanguagePicker";

//import { mapActions, mapGetters } from "vuex";
//import { handleJWT, getErrorAlertValue } from "./../util/util";
import { APPROVEAGENT } from "../util/constants";
// import apiUserLogoDet from "./../services/apiUserLogoDet";
//import Logger from "./../services/logger";
// import SERVICE_URL, {
//   FILE_NAME,
//   LOG_TYPE,
//   HTTP_CODES
// } from "./../config/API_DATA";

//import { VALIDATE_SUCCESS_RES, getErrorMessage } from "./../util/apiValidate";
import apiLogOut from "./../services/apiLogOut";

//import router, { navigate, goBack } from "./../router/index";
import store from "../store";
//import apiGetBalanceDetail from "./../services/apiGetBalanceDetail";
import BaseConfiguration from "./../config/base";
import cLoginInfo from "./../components/cLoginInfo";
//import Avatar from "vue-avatar-component";
import Avatar from "vue-avatar";
import { clearStore } from "./../store/clearStore";
import { removeB2BMFfromSession } from "./../applocalstorage/localStorage";
import gql from "graphql-tag";
import TESTQ from "./../graphql/test.gql";
  
  const SUBSCRIPTION_PENDING_AGENT_COUNT = gql`
    subscription getpending_agentcount {
        b2b_registration_aggregate(where: {status: {_eq: 1}}) {
          aggregate {
            count(columns: registrationid)
          }
        }
      }
  `;


import Vue from 'vue'
import VueApollo from 'vue-apollo'
import apolloClient,{restartWebsockets,handleApolloJWT} from './../graphql/ApolloClient'
Vue.use(VueApollo);
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    errorHandler (error) {
      if(checkIsSystemLogin()){
       handleApolloJWT(error);
      }
  }
  });
 if (BaseConfiguration.isMobile) {
  // var aSideMenu = require('./../mobile/components/aSideMenu').default;
  // var AppPageControl = require('./../mobile/containers/aPageControl').default;
} 
export default {

  apolloProvider, ///provide:apolloProvider.provide(),
  
  name: "TheSidebar",
  
  /*apollo:{
    test:{
      query: TESTQ,
      subscribeToMore: {
        document: gql`subscription getpending_agentcount {
          b2b_registration_aggregate(where: {status: {_eq: 1}}) {
            aggregate {
              count(columns: registrationid)
            }
          }
        }`,
        // below is the subscription query.
        //document: SUBSCRIPTION_PENDING_AGENT_COUNT,
        updateQuery: (previousResult, { subscriptionData }) => {
          return subscriptionData.data.b2b_registration_aggregate; // This returns our SUBSCRIPTION into the data property "items" when there is an update
        }
		 }
    }
  },*/
  apollo:{
    // Vue-Apollo options here
    //b2b_registration_aggregate: TESTQ,
     // Subscriptions
     
      $subscribe:(!(this)||checkIsSystemLogin())? {
        // When a user is added
        b2b_registration_aggregate: {
          query: SUBSCRIPTION_PENDING_AGENT_COUNT,
          // Result hook
          result (data) {
            // Let's update the local data 
            this.b2b_registration_aggregate = (data && data.data && data.data.b2b_registration_aggregate)?data.data.b2b_registration_aggregate: {aggregate : {count : 0}}
          },
          //  error(error){
          //  console.error(error)   
                
          // }
        },
      }:'',
  },
  components: {
    // aSideMenu,
    cLanguagePicker,
    cLoginInfo,
    cUserInfo,
    //avatar
    Avatar,
    TheHeaderDropdownAccnt
  },
  data() {
    return {
      //test:{},
     isMobile: BaseConfiguration.isMobile,
      lsNavMenus : [],      
      b2b_registration_aggregate : {
        aggregate : {count : 0}
      },
      version: "v" + base.version + " " + (base.isDebug ? "dev" : ""),
      minimize: false,
      isNeedLogo:false,
      nav: [],
      show: "responsive",
      isShowAlert: false,
      alertValue: null,
      //start
      showUserInfo: false,
      language: [
        {
          langcode: null,
          en_name: null,
          native_name: null
        }
      ],
      languageListURL: SERVICE_URL.LANGUAGE_LIST,
      itemsCount: 42,
      balance: {
        1: "PrePaid",
        2: "PostPaid"
      },
      alertValue: null,
      isShowLoginInfo: false,
      userLogoDet: null,
      // userLogoDet: {
      //     firstname: null,
      //     lastname: null,
      //     agencyname: null,
      //     b2bCompanyFinancess: []
      // }
      userLogoDet: {
        logoDet: null
        // b2bCompanyFinancess: []
      }
      //end
    };
  },
  computed: {
    ...mapGetters("sMenus", {
      GET_ALL_MENUS_RES: "GET_ALL_MENUS_RES"
    }),
    ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_FORMAT_RES: "GET_ORG_CURRENCY_FORMAT_RES"
    }),
       ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    getUserName: function() {
      let retValue;
      try {
        if (
          this.userLogoDet.logoDet &&
          this.userLogoDet.logoDet.firstname &&
          this.userLogoDet.logoDet.lastname
        ) {
          retValue =
            this.userLogoDet.logoDet.firstname +
            " " +
            this.userLogoDet.logoDet.lastname;
        } else if (
          this.userLogoDet.logoDet &&
          this.userLogoDet.logoDet.firstname
        ) {
          retValue = this.userLogoDet.logoDet.firstname;
        } else {
          retValue = "";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in getting user name",
          err.toString(),
          "getUserName()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ...mapGetters("sSysLogin", {
      GET_ADMIN_SIGNIN_REQ: "GET_ADMIN_SIGNIN_REQ",
      GET_ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sDashBoard", {
      userLogoDetail: "GET_AGENT_LOGO_DET_RES"
    })
  },

  methods: {
    ...mapActions("sMenus", {
      CLEAR_ALL_MENUS_STORE: "CLEAR_ALL_MENUS_STORE",
      SET_ALL_MENUS_REQ: "SET_ALL_MENUS_REQ",
      SET_ALL_MENUS_RES: "SET_ALL_MENUS_RES",
      SET_MENU_COUNT_RES: "SET_MENU_COUNT_RES"
    }),
    ...mapActions("sCurrencyLs", {
      SET_ORG_CURRENCY_FORMAT_RES: "SET_ORG_CURRENCY_FORMAT_RES",
      SET_ORG_CURRENCIES: "SET_ORG_CURRENCIES",
      SET_ORG_CURRENCY_RES: "SET_ORG_CURRENCY_RES"
    }),
    //start
    ...mapActions("sSysLogin", {
      CLEAR_SYS_LOGIN: "CLEAR_SYS_LOGIN"
    }),
    ...mapActions("sAgtLogin", {
      CLEAR_AGT_LOGIN: "CLEAR_AGT_LOGIN"
    }),
    // ...mapActions('sDashBoard',{
    //     SET_AGENT_LOGO_DET_REQUEST:'SET_AGENT_LOGO_DET_REQUEST',
    //     SET_AGENT_LOGO_DET_RESPONSE:'SET_AGENT_LOGO_DET_RESPONSE',
    //    // SET_AGENT_FINANCE_RESPONSE:'SET_AGENT_FINANCE_RESPONSE'
    //     }),

    /*viewBalance(val) {
      alert(JSON.stringify(val));
    },*/
    goTo(){
      navigateReplace(PATHNAME.DASHBOARD);
    },
    showAlert(val) {
      this.alertValue = val;
    },

    toggleShowLoginInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleShowLoginInfo");
        //let retValue;
        this.isShowLoginInfo = !this.isShowLoginInfo;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in toggleShowLoginInfo",
          err.toString(),
          "toggleShowLoginInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //return retValue;
    },
    onLogout() {
      try {
        removeB2BMFfromSession();

        clearStore();
        apiLogOut.getLogout();
        // this.CLEAR_AGT_LOGIN();
        // this.CLEAR_SYS_LOGIN();
        if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.SYSTEM_LOGIN);
        } else if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.AGENT_LOGIN);
        } else {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.AGENT_LOGIN);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in onLogout",
          err.toString(),
          "onLogout",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    //end

    async getSideMenus() {
      let returnValue;
      try {
        let allMenusReq = apiGetMenus.buildRequest();

        if (allMenusReq != null) {
          this.SET_ALL_MENUS_REQ(allMenusReq);

          let allMenusRes = await apiGetMenus.getResponse(allMenusRes);
          if (VALIDATE_SUCCESS_RES(allMenusRes)) {
            returnValue = allMenusRes.data.data;
            if(BaseConfiguration.isMobile) {
            returnValue = this.$AppPageControl.appSideBarMenu(returnValue);
            }
           
            this.SET_ALL_MENUS_RES(returnValue);
          } else {
            let error = getErrorMessage(allMenusRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            } else {
              returnValue = [];
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in getiing SideMenus",
          err.toString(),
          "getSideMenus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getMenuCount() {
      let returnValue;
      try {
        let menuCountReq = apiGetMenuCount.buildRequest();

        if (menuCountReq != null) {
          let menuCountRes = await apiGetMenuCount.getResponse(menuCountReq);
          if (VALIDATE_SUCCESS_RES(menuCountRes)) {
            returnValue = menuCountRes.data.data;
            this.SET_MENU_COUNT_RES(returnValue);
          } else {
            let error = getErrorMessage(menuCountRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            } else {
              returnValue = [];
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in getting getMenuCount",
          err.toString(),
          "getMenuCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    sortSubMenus(pMenuList) {
      let returnValue;
      try {
        if (pMenuList && pMenuList.length > 0) {
          pMenuList.forEach(menu => {
            if (menu.child && menu.child.length > 0) {
              menu.child.sort(function(subMenu1, subMenu2) {
                if (
                  Number(subMenu1.displayorder) >
                  Number(subMenu2.displayorder)
                ) {
                  return 0;
                } else {
                  return -1;
                }
              });
            }
          });

          returnValue = pMenuList;
        } else {
          returnValue = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in   sorting Sub Menus",
          err.toString(),
          "sortSubMenus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    sortMenus(pMenuList) {
      let returnValue;
      try {
        if (pMenuList && pMenuList.length > 0) {
          returnValue = pMenuList.sort(function(menu1, menu2) {
            if (parseInt(menu1.displayorder) > parseInt(menu2.displayorder)) {
              return 0;
            } else {
              return -1;
            }
          });
        } else {
          returnValue = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in   sorting Menus",
          err.toString(),
          "sortMenus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    filterMenus(pMenuList) {
      let returnValue;
      let lsFilteredMenus = [];
      try {
        if (pMenuList && pMenuList.length > 0) {
          pMenuList.forEach(menu => {
            if (menu && menu.child.length > 0) {
              let subMenuList = [];
              menu.child.forEach(submenu => {
                subMenuList.push({
                  name: submenu.menuname,
                  isOpen:false,
                  to: submenu.routing ? submenu.routing : PATHNAME.DASHBOARD,
                  icon: submenu.icon
                });
              });

              lsFilteredMenus.push({
                _name: "CSidebarNavDropdown",
                name: menu.menuname,
                icon: menu.icon,
                isOpen:false,
                to: menu.routing ? menu.routing : PATHNAME.DASHBOARD,
                items: subMenuList
              });
            } else {
              lsFilteredMenus.push({
                _name: "CSidebarNavItem",
                name: menu.menuname,
                isOpen:false,
                icon: menu.icon,
                to: menu.routing ? menu.routing : PATHNAME.DASHBOARD
              });
            }
          });

          returnValue = lsFilteredMenus;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in Filter Menus",
          err.toString(),
          "filterMenus()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    //api call to get orgcurrency list
    async getCurrencyFormatRes() {
      let retValue;
      try {
        let orgcurrencyLsResponse = await apiGetOrgCurrencyLs.getResponse();
        if (
          VALIDATE_SUCCESS_RES(orgcurrencyLsResponse) &&
          orgcurrencyLsResponse.data.data.length > 0
        ) {
          // this.SET_CURRENCY_RES(currencyLsResponse.data.data); //save res in store
          this.SET_ORG_CURRENCY_RES(
            JSON.parse(JSON.stringify(orgcurrencyLsResponse))
          );
          retValue = orgcurrencyLsResponse.data;

          let orgCurrencies = {};
          orgcurrencyLsResponse.data.data.forEach(currency => {
            orgCurrencies[currency.currency_code] = JSON.parse(
              JSON.stringify(currency)
            );
          });

          this.SET_ORG_CURRENCIES(orgCurrencies);
          this.SET_ORG_CURRENCY_FORMAT_RES(orgcurrencyLsResponse);
        } else {
          this.isShowAlert = true;

          let error = getErrorMessage(orgcurrencyLsResponse);

          let isJwt = handleJWT(error);
          if (!isJwt) {
            this.alertValue = getErrorAlertValue(error);
          }
        }

        //  } else {
        //     throw "invalid country request";
        //   }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.API_GET_CURRENCY_LIST,
          "error in getting response from GetCurrencyLs API",
          err.toString(),
          "GetCurrencyLsRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    toAddBadge(pLsMenus,pMenucountObj) {      
      let retValue;
      let badge = {
        color: null,
        text: null,
        class: null
      };
      let tag;
      try {
        if(pLsMenus&&pLsMenus.length){
        for (let i = 0; i < pLsMenus.length; i++) {
          if (pLsMenus[i]&&pLsMenus[i].items&&pLsMenus[i].items.length) {
            for (let j = 0; j < pLsMenus[i].items.length; j++) {
              if (pLsMenus[i].items[j].to == PATHNAME.APPROVE_AGENT) {
                /*if(pMenucountObj !=0){
                  this.$set(pLsMenus[i].items[j], "badge", {
                    color: "primary",
                    text: this.b2b_registration_aggregate.aggregate.count
                  });
                }else{
                  this.$set(pLsMenus[i].items[j], "badge", {
                    color: "primary",
                    class: "zero",
                    text: 0//pMenucountObj.pendingApprovalCount
                  });
                }*/
                if (pMenucountObj || 
                  this.b2b_registration_aggregate &&
                  this.b2b_registration_aggregate.aggregate &&
                  this.b2b_registration_aggregate.aggregate.count>0
                ) {
                  pLsMenus[i].items[j].badge = {
                    color: "primary",
                    text: pMenucountObj?pMenucountObj: this.b2b_registration_aggregate.aggregate.count
                  };                  
                } else {
                  pLsMenus[i].items[j].badge = {
                    color: "primary",
                    class: "zero",
                    text: 0//this.b2b_registration_aggregate.aggregate.count
                  };           
                }
                break;
              }
              /* else if( pLsMenus[i].items[j].to == PATHNAME.MANAGE_AGENT)
             {
                this.$set(pLsMenus[i].items[j],'badge',{'color':'primary',
                        'text':pMenucountObj.totalAgents});
              
             }*/
            }
          }
        }
        }
        retValue = pLsMenus;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SIDE_BAR,
          "error in toAddBadge",
          err.toString(),
          "toAddBadge",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },

  async created() {
    // if (base.showMenu) {
    try {
      // restartWebsockets()
      // if(this.isSystemLogin){
      // this.$apollo.queries.refetch();

      // }
      // this.$apollo.mutate(update:);
      let lsMenus;
      //start
      if (BaseConfiguration.isDebug) console.log("created");
      let logoDetail = null;
      if (this.userLogoDetail) logoDetail = this.userLogoDetail;
      //logoDetail.roles.push('hello')
      if (logoDetail) this.userLogoDet.logoDet = logoDetail;
      //end

      if (this.GET_ALL_MENUS_RES) {
        lsMenus = this.GET_ALL_MENUS_RES;
      } else {
        lsMenus = await this.getSideMenus();
      }

      await this.getCurrencyFormatRes();

      let menuCount = await this.getMenuCount();///get to show counts in manage agent

      ///from temp
      // lsMenus = JSON.parse(JSON.stringify(menu));
      lsMenus = this.sortMenus(lsMenus);
      lsMenus = this.sortSubMenus(lsMenus);

      lsMenus = this.filterMenus(lsMenus);
      /*if(menuCount.pendingApprovalCount!=null && menuCount.pendingApprovalCount!=undefined)
        lsMenus = this.toAddBadge(lsMenus,menuCount.pendingApprovalCount);
      else
        lsMenus = this.toAddBadge(lsMenus,0);//default 0*/
      lsMenus = this.toAddBadge(lsMenus);
      this.lsNavMenus = lsMenus;
      this.nav.push({
        _name: "CSidebarNav",
        _children: lsMenus
      });
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.SIDE_BAR,
        "error in Created",
        err.toString(),
        "Created()",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    // }
    // else {
    //   this.nav = nav;
    // }
  },
  watch: {
    // whenever sidebar minimied changes, this function will run
    minimize: function(newMinimize, oldMinimize) {
      if (newMinimize) {
        addClassToContainer(false);
      } else {
        addClassToContainer(true);
      }
    },
    'b2b_registration_aggregate.aggregate.count': function(newCount, oldCount) {
      if(this.lsNavMenus.length>0){
          let lsMenus = this.toAddBadge(this.lsNavMenus,newCount);
              /*this.lsNavMenus[1].items[0].badge = {zz
                          color: "primary",
                          class:newCount?'':'zero',
                          text: newCount
                        };        */
              this.nav.push({
                _name: "CSidebarNav",          
                _children: lsMenus
              });
      }
        
    },
  },
  mounted() {
    this.$root.$on("toggle-sidebar", isClose => {
      // console.error(this.show)
      // if(this.show==undefined)
      // {
      // this.$root.$emit("recreate-sidebar", true);

      // }
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
      if (isClose) {
        // console.error('isClo')
        this.show = false;
      } else {
        this.show = true;

        //        let that = this;
        // setTimeout(() => {
        //  that.show =true;
        // },100);
      }
     

      // console.log(this.show);
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
    this.$root.$on("toggle-sidebar-minimize", isMaximize => {
      if (isMaximize) {
        this.minimize = false;
                this.isNeedLogo=false;

      } else {
        this.minimize = true;
                        this.isNeedLogo=true;

      }
    });
  }
};
</script>
